import { inject, Injectable } from '@angular/core';
import { AlertController, AlertOptions } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly alertController: AlertController = inject(AlertController);

  async presentAlert(opts: AlertOptions): Promise<void> {
    const alert: HTMLIonAlertElement = await this.alertController.create({
      header: opts.header,
      subHeader: opts.subHeader,
      message: opts.message,
      buttons: opts.buttons
    });

    await alert.present();
  }
}
